import {action, computed, observable, extendObservable} from "mobx";

export const StatusConstants = {
    RENDERING: 0,
    READY: 5,
};

class UiStateStore {

    constructor() {
        this.loader = observable({
            status: StatusConstants.READY,
            processing: true,
            type: 'loader',
            message: 'Momencik, ładujemy...',
        });

        // Because @computed somehow screws up the scope with 'this' being undefined.
        extendObservable(this, {
            shouldShowDimmer: computed(function () {
                return this.loader.status === StatusConstants.RENDERING;
            })
        })
    }

    @action setStatus(state) {
        this.loader.status = state;
    }

    @action setDimmerState(state) {
        this.loader = Object.assign(this.loader, state);
    }
}

const uiStateStore = new UiStateStore();

export default uiStateStore


// WEBPACK FOOTER //
// ./src/core/uiState.js